// extracted by mini-css-extract-plugin
export default {"root":"EligibleProductsLimitCard_root__OmIg1"};